import { render, staticRenderFns } from "./PersonalPage.vue?vue&type=template&id=518992a8&scoped=true"
import script from "./PersonalPage.vue?vue&type=script&lang=js"
export * from "./PersonalPage.vue?vue&type=script&lang=js"
import style0 from "./PersonalPage.vue?vue&type=style&index=0&id=518992a8&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518992a8",
  null
  
)

export default component.exports